
webpack.register(
    'blocks/navigation/history-experience-header/history-experience-header',
    function() {
        return import('blocks/navigation/history-experience-header/history-experience-header');
    },
    true
);

webpack.register(
    'components/geo-targeted-interstitial/geo-targeted-interstitial',
    function() {
        return import('components/geo-targeted-interstitial/geo-targeted-interstitial');
    },
    true
);